





































































import { Component, Mixins } from "vue-property-decorator";
import { BrowserPdfPrinter } from "../../../base/components/system";
import {
  HeaderPane,
  RightSidePane,
  MenuPane,
  NavigationPane,
} from "../../../base/components/panes";
import { IExternalMenuItemConfiguration } from "../../../base/domain/configuration";
import { DomainRegistry } from "../../domain";
import { IConfiguration } from "../../domain/configuration";
import { EditableFormatSummary } from "../../domain/editableFormat";
import { EditableFormatSummaryTreeSelectDialog } from "./editors/contents/commonComponents/dialogs";
import { ExternalMenu } from "./menus";
import { FormatArchiveSelector } from "./selectors";
import { FormatListViewer } from "./viewers";
import { FormatTreeSource, ITreeSource } from "./selectors/trees/sources";

@Component({
  components: {
    HeaderPane,
    RightSidePane,
    MenuPane,
    NavigationPane,
    FormatListViewer,
    FormatArchiveSelector,
    EditableFormatSummaryTreeSelectDialog,
    BrowserPdfPrinter,
    ExternalMenu,
  },
})
export default class FormatListView extends Mixins() {
  $refs!: {
    treeSelectDialog: EditableFormatSummaryTreeSelectDialog,
    pdfPrinter: BrowserPdfPrinter,
  };
  $configuration!: IConfiguration;

  selectedFormat: EditableFormatSummary = null;
  selectedArchive: EditableFormatSummary = null;
  selectedListTabName: string = "";
  treeSource: ITreeSource<number, EditableFormatSummary> = new FormatTreeSource();

  data(): any {
    return {
      isLoading: false,
    };
  }
  isLoading: boolean;

  get isSelected(): boolean {
    return !!this.selectedFormat;
  }

  get validSelected(): boolean {
    return this.isSelected && !this.selectedFormat.deleted;
  }

  get invalidSelected(): boolean {
    return this.isSelected && this.selectedFormat.deleted;
  }

  get noneDisplayFormatSelected(): boolean {
    return this.isSelected && (this.selectedListTabName === ("削除・非表示" + this.formatNameWording)) && !this.selectedFormat.deleted;
  }

  get selectedFormatId(): number {
    return this.isSelected
      ? this.selectedFormat.id
      : null;
  }

  get isArchiveSelected(): boolean {
    return this.selectedFormat
        && this.selectedArchive
        && (this.selectedArchive.edition < this.selectedFormat.edition)
        && !this.selectedFormat.deleted;
  }

  get selectedArchiveId(): number {
    return this.selectedArchive
      ? this.selectedArchive.archiveId
      : null;
  }

  get externalMenuItems(): IExternalMenuItemConfiguration[] {
    return this.$configuration.formatEditor.behavior.format.list.externalMenus;
  }

  get formatNameWording(): string {
    return this.$wording.format.name;
  }

  async revertEdition(): Promise<void> {
    if (await this.confirmToRevertEdition()) {
      const repository = DomainRegistry.instance.editableFormat.getFormatRepository();
      const result = await repository.revertFormatEdition(this.selectedFormat.id, this.selectedArchiveId);
      if (result.result) {
        this.$successAsHTML(
          "登録完了"
          , "<div>選択した版数の" + this.formatNameWording + "を最新" + this.formatNameWording + "として登録しました。</div>");
      } else {
        this.$error(
          "登録失敗"
          , "選択した版数の" + this.formatNameWording + "に戻すことができませんでした。");
      }
    }
  }

  private async confirmToRevertEdition(): Promise<boolean> {
    const index = await this.$commonDialogs.confirmation.show({
      message: [
        "現在選択されている版の内容を最新版として登録し直します。",
        "(登録してもこれまでに登録された版が消える事はありません。)",
        "本当によろしいですか？",
      ],
      buttons: [
        {
          kind: "confirm",
          label: "中止する",
        },
        {
          kind: "danger",
          label: "登録する",
        },
      ],
    });
    return (index === 1);
  }

  async deleteFormat(): Promise<void> {
    if (await this.confirmToDeleteFormat()) {
      try {
        this.isLoading = true;
        const repository = DomainRegistry.instance.editableFormat.getFormatRepository();
        await repository.deleteFormat(this.selectedFormat.id);
        this.refresh();
        this.$successAsHTML(
          "削除完了"
          , "<div>選択した" + this.formatNameWording + "を削除しました。</div>");
      } catch (e) {
        this.$error(
          "削除失敗"
          , "選択した" + this.formatNameWording + "の削除ができませんでした。");
        console.error(e);
      } finally {
        this.isLoading = false;
      }

    }
  }

  private refresh(): void {
    window.postMessage(JSON.stringify({
      key: "finishEditing", // 文書登録時のリフレッシュのメッセージで暫定対応.必要なら見直す事.
    }), "*");
  }

  private async confirmToDeleteFormat(): Promise<boolean> {
    const index = await this.$commonDialogs.confirmation.show({
      message: [
        this.formatNameWording + "を削除します。",
        "本当によろしいですか？",
      ],
      buttons: [
        {
          kind: "confirm",
          label: "中止する",
        },
        {
          kind: "danger",
          label: "削除する",
        },
      ],
    });
    return (index === 1);
  }

  previewDocument(): void {
    if (!this.selectedFormat) {
      return;
    }
    this.$openWindow(
      "/PreviewNewDocument",
      {
        formatId: this.selectedFormat.id.toString(),
        archiveId: this.selectedArchiveId ? this.selectedArchiveId.toString() : null,
      }
    );
  }

  printFormat(): void {
    this.$refs.pdfPrinter.printSource(this.selectedFormat.previewSource.source);
  }

  async reviveFormat(): Promise<void> {
    if (await this.confirmToReviveFormat()) {
      const parentId = await this.$refs.treeSelectDialog.show();
      if (!parentId) {
        return;
      }
      try {
        const repository = DomainRegistry.instance.editableFormat.getFormatRepository();
        await repository.reviveFormat(this.selectedFormat.id, parentId);
        this.$successAsHTML(
          "削除取り消し完了"
          , "<div>選択した" + this.formatNameWording + "を有効にしました。</div>");
      } catch (e) {
        this.$error(
          "削除取り消し失敗"
          , "選択した" + this.formatNameWording + "を有効に戻すことができませんでした。");
      }
    }
  }

  private async confirmToReviveFormat(): Promise<boolean> {
    const index = await this.$commonDialogs.confirmation.show({
      message: [
        "削除済みの" + this.formatNameWording + "を有効に戻します",
        "本当によろしいですか？",
      ],
      buttons: [
        {
          kind: "confirm",
          label: "中止する",
        },
        {
          kind: "danger",
          label: "有効にする",
        },
      ],
    });
    return (index === 1);
  }

  async redisplayFormat(): Promise<void> {
    if (await this.confirmToRedisplayFormat()) {
      const parentId = await this.$refs.treeSelectDialog.show();
      if (!parentId) {
        return;
      }
      try {
        const repository = DomainRegistry.instance.editableFormat.getFormatRepository();
        await repository.redisplayFormat(this.selectedFormat.id, parentId);
        this.$successAsHTML(
          "再表示完了"
          , "<div>選択した" + this.formatNameWording + "を再表示しました。</div>");
      } catch (e) {
        this.$error(
          "再表示失敗"
          , "選択した" + this.formatNameWording + "を再表示することができませんでした。");
      }
    }
  }

  private async confirmToRedisplayFormat(): Promise<boolean> {
    const index = await this.$commonDialogs.confirmation.show({
      message: [
        "階層に表示されない" + this.formatNameWording + "を再表示します。",
        "本当によろしいですか？",
      ],
      buttons: [
        {
          kind: "confirm",
          label: "中止する",
        },
        {
          kind: "danger",
          label: "再表示する",
        },
      ],
    });
    return (index === 1);
  }

  createFormat(): void {
    this.$openWindow(
      "/EditNewFormat",
    );
  }

  editFormat(): void {
    if (!this.selectedFormat) {
      return;
    }
    this.$openWindow(
      "/EditFormat",
      {
        formatId: this.selectedFormat.id.toString(),
      }
    );
  }

  selectedListTabChanged(name: string): void {
    this.selectedListTabName = name;
  }

  createCopiedFormat(): void {
    if (!this.selectedFormat) {
      return;
    }
    this.$openWindow(
      "/EditNewCopiedFormat",
      {
        formatId: this.selectedArchive.id.toString(),
        archiveId: this.selectedArchive.archiveId.toString(),
      }
    );
  }

  showFormat(): void {
    if (!this.selectedFormat) {
      return;
    }
    this.$openWindow(
      "/ShowFormat",
      {
        formatId: this.selectedFormat.id.toString(),
        archiveId: this.selectedArchiveId ? this.selectedArchiveId.toString() : null,
      }
    );
  }
}
